import { Ticket } from '../types/interfaces/ticket';
import { User } from '../types/interfaces/user';

export function canViewTicket(
  ticket: Pick<Ticket, 'idAgent' | 'idQueue'>,
  user: Pick<User, 'id' | 'queues'> | undefined,
): boolean {
  if (user?.id == null) {
    return false;
  }

  if (ticket.idAgent != null) {
    return ticket.idAgent === user.id;
  }

  return (
    ticket.idQueue == null || Boolean(user.queues?.includes(ticket.idQueue))
  );
}
